import { Collapse, Link, List } from "@mui/material";
import { useRouter } from "next/router";
import { useState } from "react";

import { getActive, isExternalLink } from "..";
import { NavListProps } from "../type";

import NavItem from "./NavItem";

type NavListRootProps = {
	data: NavListProps;
	depth: number;
	hasChildren: boolean;
	isCollapse?: boolean;
};

export default function NavList({ data, depth, hasChildren, isCollapse = false }: NavListRootProps) {
	const { pathname, asPath, push } = useRouter();

	const active = getActive(data.path, pathname, asPath);

	const [open, setOpen] = useState(active);

	const handleClickItem = () => {
		if (!hasChildren) {
			push(data.path);
		}
		setOpen(!open);
	};

	return (
		<>
			{isExternalLink(data.path) ? (
				<Link href={data.path} target="_blank" rel="noopener" underline="none">
					<NavItem item={data} depth={depth} open={open} active={active} isCollapse={isCollapse} />
				</Link>
			) : (
				<NavItem
					item={data}
					depth={depth}
					open={open}
					active={active}
					isCollapse={isCollapse}
					onClick={handleClickItem}
				/>
			)}

			{!isCollapse && hasChildren && (
				<Collapse in={open} unmountOnExit>
					<List component="div" disablePadding>
						<NavSubList data={data.children} depth={depth} />
					</List>
				</Collapse>
			)}
		</>
	);
}

type NavListSubProps = {
	data: NavListProps[];
	depth: number;
};

function NavSubList({ data, depth }: NavListSubProps) {
	return (
		<>
			{data.map((list) => (
				<NavList key={list.title + list.path} data={list} depth={depth + 1} hasChildren={!!list.children} />
			))}
		</>
	);
}
